import { createFileRoute } from '@tanstack/react-router';
import { ProviderCredentialsSettings } from '@/components/providers/provider-credentials-settings';

export const Route = createFileRoute(
  '/_auth/_side-layout/super-admin/visitor-id/providers',
)({
  component: () => (
    <ProviderCredentialsSettings
      header={false}
      capabilities={['visitor']}
      providerIds={['ipapi_is', 'ipregistry']}
      title="Company Resolution Providers"
      description="Credentials for the reverse-IP company providers (ipapi.is, Ipregistry). Stored encrypted; secrets are write-only."
    />
  ),
});
